"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Format north american phone number
 *
 * @param {string} number
 * @returns {string} - number in 000-000-0000 format
 */
const formatPhoneNumber = (number) => {
    return number ? number.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3') : '';
};
exports.default = formatPhoneNumber;
//# sourceMappingURL=formatPhoneNumber.js.map